import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchYachtGroups = createAsyncThunk(
  "yachtGroups/fetch",
  async () => {
    const { data } = await api.get("/yacht-groups");
    return data.groups;
  },
);

const yachtGroupsSlice = createSlice({
  name: "yachtGroups",
  initialState: {
    items: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchYachtGroups.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchYachtGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchYachtGroups.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default yachtGroupsSlice.reducer;
